module.exports = __webpack_public_path__ + "img/ETH.26d4af6c.svg";